export default __webpack_public_path__ + "static/media/logo-full.01c2344a.svg";